<ng-template #defaultTabButtons let-c="close" let-d="dismiss">

    <div class="backgroundTable text-white" ngbAutofocus>
    <div class=" mx-5 ">
      <div class="row  my-2">
        <div class="col-9 align-self-center p-2 bd-highlight">Información de Pagos</div>
        
        <div class="col-3 d-flex flex-row-reverse bd-highlight p-2 "><button type="button" ngbAutofocus aria-label="Close"  (click)="d('Cross click')" class="btn btn-outline-danger">Cerrar</button></div>
      </div>
    </div>
    <div class="componente-importantes-from">
        <div class="row mx-5 ">
            <div class="col-md-12 my-2">
                <label class="form-label">{{item.title}}</label>
            </div>
            <div *ngIf="item.realDate != null" class="col-md-12 my-2">
                <label class="form-label">{{item.realDate}}</label>
            </div>
            <div *ngIf="item.scheduledDate != null && item.status != 5" class="col-md-12 my-2">
                <label class="form-label">{{item.scheduledDate}}</label>
            </div>
            <div *ngIf="item.rescheduledDate != null" class="col-md-12 my-2">
                <label class="form-label">{{item.rescheduledDate}}</label>
            </div>
            <div class="col-md-12 my-2">
                <label class="form-label">{{item.detail}}</label>
            </div>
        </div>
    </div>
  </div>

</ng-template>
